import { useRef, useState, useCallback } from 'react';

// Zero-friction bot protection: a hidden honeypot field + a submit-timing trap.
// Real customers never see or touch the honeypot; bots fill every field and
// submit instantly, so the backend can drop those submissions silently.
export function useAntiBot() {
  const mountedAt = useRef(Date.now());
  const [hp, setHp] = useState('');
  const appendAntiBot = useCallback((fd) => {
    fd.append('website', hp || '');
    fd.append('elapsed', String(Date.now() - mountedAt.current));
  }, [hp]);
  return { hp, setHp, appendAntiBot };
}

export function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}>
      <label>Website (leave this field empty)
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
